export default "__VITE_ASSET__HvqSMGSM__"